import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding-top: 0.5rem;

  @media (min-width: 1024px) {
    padding-top: 0;
  }
`;

const EducationList = styled.div`
  word-break: break-word;
`;

const EducationItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.5rem;
  }
`;

const Period = styled.div`
  font-size: 0.75rem;
  line-height: 1.35;
  color: #374151;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const Degree = styled.h4`
  font-size: 0.875rem;
  line-height: 1.35;
  font-weight: 700;
  color: #111827;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const Institution = styled.p`
  margin: 8px 0 0;
  font-size: 0.8125rem;
  line-height: 1.35;
  color: #374151;

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

export default function EducationSection() {
  return (
    <Wrapper>
      <EducationList>
        <EducationItem>
          <Period>2016 - 2019</Period>

          <div>
            <Degree>Bachelor's degree in computer applications</Degree>
            <Institution>Panjab University - Chandigarh, India</Institution>
          </div>
        </EducationItem>
      </EducationList>
    </Wrapper>
  );
}
